import { KeepAwake } from '@capacitor-community/keep-awake';

export class KeepDeviceAwake {

  static async keepAwake() {
    // console.log('allow sleep isSupported:', await this.isSupported());
    if (await this.isSupported()) {
      await KeepAwake.keepAwake();
      console.log('Keeping device awake');
    } else {
      console.log('This browser does not support keep awake.')
    }
  }

  static async allowSleep() {
    if (await this.isSupported()) {
      console.log('Allow device to sleep');
      await KeepAwake.allowSleep();
    }
  }

  static async isSupported() {
    const result = await KeepAwake.isSupported();
    return result.isSupported;
  }
}